export interface TimezoneInfo {
  timezone: string;
  country: string;
  city: string;
  utcOffset: string;
}

export const TIMEZONES: TimezoneInfo[] = [
  // UTC-12 to UTC-1
  {timezone: "Pacific/Baker Island", country: "US (Baker Island)", city: "Baker Island", utcOffset: "UTC-12"},
  {timezone: "Pacific/Honolulu", country: "US (Hawaii)", city: "Honolulu", utcOffset: "UTC-10"},
  {timezone: "America/Anchorage", country: "US (Alaska)", city: "Anchorage", utcOffset: "UTC-9"},
  {timezone: "America/Los_Angeles", country: "US (Pacific)", city: "Los Angeles", utcOffset: "UTC-8"},
  {timezone: "America/Denver", country: "US (Mountain)", city: "Denver", utcOffset: "UTC-7"},
  {timezone: "America/Chicago", country: "US (Central)", city: "Chicago", utcOffset: "UTC-6"},
  {timezone: "America/New_York", country: "US (Eastern)", city: "New York", utcOffset: "UTC-5"},
  {timezone: "America/Sao_Paulo", country: "Brazil", city: "São Paulo", utcOffset: "UTC-3"},
  {timezone: "Atlantic/South_Georgia", country: "South Georgia", city: "South Georgia", utcOffset: "UTC-2"},

  // UTC+0
  {timezone: "UTC", country: "UTC/GMT", city: "UTC", utcOffset: "UTC+0"},
  {timezone: "Europe/London", country: "UK", city: "London", utcOffset: "UTC+0"},
  {timezone: "Africa/Abidjan", country: "Ivory Coast", city: "Abidjan", utcOffset: "UTC+0"},
  {timezone: "Atlantic/Reykjavik", country: "Iceland", city: "Reykjavik", utcOffset: "UTC+0"},

  // UTC+1 to UTC+3
  {timezone: "Europe/Paris", country: "France", city: "Paris", utcOffset: "UTC+1"},
  {timezone: "Europe/Berlin", country: "Germany", city: "Berlin", utcOffset: "UTC+1"},
  {timezone: "Europe/Rome", country: "Italy", city: "Rome", utcOffset: "UTC+1"},
  {timezone: "Europe/Madrid", country: "Spain", city: "Madrid", utcOffset: "UTC+1"},
  {timezone: "Europe/Amsterdam", country: "Netherlands", city: "Amsterdam", utcOffset: "UTC+1"},
  {timezone: "Europe/Zurich", country: "Switzerland", city: "Zurich", utcOffset: "UTC+1"},
  {timezone: "Europe/Warsaw", country: "Poland", city: "Warsaw", utcOffset: "UTC+1"},
  {timezone: "Europe/Stockholm", country: "Sweden", city: "Stockholm", utcOffset: "UTC+1"},
  {timezone: "Europe/Oslo", country: "Norway", city: "Oslo", utcOffset: "UTC+1"},
  {timezone: "Europe/Copenhagen", country: "Denmark", city: "Copenhagen", utcOffset: "UTC+1"},
  {timezone: "Europe/Helsinki", country: "Finland", city: "Helsinki", utcOffset: "UTC+2"},
  {timezone: "Europe/Athens", country: "Greece", city: "Athens", utcOffset: "UTC+2"},
  {timezone: "Europe/Bucharest", country: "Romania", city: "Bucharest", utcOffset: "UTC+2"},
  {timezone: "Europe/Istanbul", country: "Turkey", city: "Istanbul", utcOffset: "UTC+3"},
  {timezone: "Europe/Moscow", country: "Russia", city: "Moscow", utcOffset: "UTC+3"},
  {timezone: "Africa/Cairo", country: "Egypt", city: "Cairo", utcOffset: "UTC+2"},
  {timezone: "Africa/Lagos", country: "Nigeria", city: "Lagos", utcOffset: "UTC+1"},
  {timezone: "Africa/Johannesburg", country: "South Africa", city: "Johannesburg", utcOffset: "UTC+2"},
  {timezone: "Africa/Nairobi", country: "Kenya", city: "Nairobi", utcOffset: "UTC+3"},
  {timezone: "Asia/Baghdad", country: "Iraq", city: "Baghdad", utcOffset: "UTC+3"},
  {timezone: "Asia/Riyadh", country: "Saudi Arabia", city: "Riyadh", utcOffset: "UTC+3"},
  {timezone: "Asia/Tehran", country: "Iran", city: "Tehran", utcOffset: "UTC+3:30"},

  // UTC+4 to UTC+6
  {timezone: "Asia/Dubai", country: "UAE", city: "Dubai", utcOffset: "UTC+4"},
  {timezone: "Asia/Baku", country: "Azerbaijan", city: "Baku", utcOffset: "UTC+4"},
  {timezone: "Asia/Karachi", country: "Pakistan", city: "Karachi", utcOffset: "UTC+5"},
  {timezone: "Asia/Tashkent", country: "Uzbekistan", city: "Tashkent", utcOffset: "UTC+5"},
  {timezone: "Asia/Kolkata", country: "India", city: "Mumbai", utcOffset: "UTC+5:30"},
  {timezone: "Asia/Colombo", country: "Sri Lanka", city: "Colombo", utcOffset: "UTC+5:30"},
  {timezone: "Asia/Kathmandu", country: "Nepal", city: "Kathmandu", utcOffset: "UTC+5:45"},
  {timezone: "Asia/Dhaka", country: "Bangladesh", city: "Dhaka", utcOffset: "UTC+6"},
  {timezone: "Asia/Almaty", country: "Kazakhstan", city: "Almaty", utcOffset: "UTC+6"},
  {timezone: "Asia/Bishkek", country: "Kyrgyzstan", city: "Bishkek", utcOffset: "UTC+6"},

  // UTC+7 to UTC+9
  {timezone: "Asia/Bangkok", country: "Thailand", city: "Bangkok", utcOffset: "UTC+7"},
  {timezone: "Asia/Ho_Chi_Minh", country: "Vietnam", city: "Ho Chi Minh", utcOffset: "UTC+7"},
  {timezone: "Asia/Jakarta", country: "Indonesia", city: "Jakarta", utcOffset: "UTC+7"},
  {timezone: "Asia/Shanghai", country: "China", city: "Shanghai", utcOffset: "UTC+8"},
  {timezone: "Asia/Hong_Kong", country: "Hong Kong", city: "Hong Kong", utcOffset: "UTC+8"},
  {timezone: "Asia/Singapore", country: "Singapore", city: "Singapore", utcOffset: "UTC+8"},
  {timezone: "Asia/Taipei", country: "Taiwan", city: "Taipei", utcOffset: "UTC+8"},
  {timezone: "Asia/Manila", country: "Philippines", city: "Manila", utcOffset: "UTC+8"},
  {timezone: "Asia/Kuala_Lumpur", country: "Malaysia", city: "Kuala Lumpur", utcOffset: "UTC+8"},
  {timezone: "Australia/Perth", country: "Australia", city: "Perth", utcOffset: "UTC+8"},
  {timezone: "Asia/Seoul", country: "South Korea", city: "Seoul", utcOffset: "UTC+9"},
  {timezone: "Asia/Tokyo", country: "Japan", city: "Tokyo", utcOffset: "UTC+9"},
  {timezone: "Asia/Pyongyang", country: "North Korea", city: "Pyongyang", utcOffset: "UTC+9"},

  // UTC+10 to UTC+14
  {timezone: "Australia/Sydney", country: "Australia", city: "Sydney", utcOffset: "UTC+10"},
  {timezone: "Australia/Melbourne", country: "Australia", city: "Melbourne", utcOffset: "UTC+10"},
  {timezone: "Pacific/Guam", country: "Guam", city: "Guam", utcOffset: "UTC+10"},
  {timezone: "Pacific/Auckland", country: "New Zealand", city: "Auckland", utcOffset: "UTC+12"},
  {timezone: "Pacific/Fiji", country: "Fiji", city: "Suva", utcOffset: "UTC+12"},
  {timezone: "Pacific/Tongatapu", country: "Tonga", city: "Nuku'alofa", utcOffset: "UTC+13"},
  {timezone: "Pacific/Kiritimati", country: "Kiribati", city: "Kiritimati", utcOffset: "UTC+14"},
];

export function getCurrentTime(timezone: string): string {
  try {
    return new Date().toLocaleTimeString("en-US", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  } catch {
    return "N/A";
  }
}

export function getCurrentDate(timezone: string): string {
  try {
    return new Date().toLocaleDateString("en-US", {
      timeZone: timezone,
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "N/A";
  }
}
